import { TLCEventManager } from "../../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { ApplicationData } from "../../ApplicationData";
import { LS2PAC_Utils } from "../../utils/Utils";
import { TitlesSearchClientManager } from "./TitlesSearchClientManager";

export class WorldbookSearchClientManager extends TitlesSearchClientManager {
  constructor(options) {
	super(options);
    this.originalPageSize = options.pageSize;
    
    this.addExtraListeners();
    this.currentDb = null;
    this.worldBookDatabaseList = this.getDefaultWorldbookDatabaseList();
  }
  getDefaultWorldbookDatabaseList() {
    var allDBs = ApplicationData.locationConfiguration.getWorldBookDatabases();
    var firstEnabledItem = null;

    for (var i = 0, len = allDBs.length; i < len; i += 1) {
      var next = allDBs[i];

      if (next.useThis) {
        if (!firstEnabledItem) {
          firstEnabledItem = next;
        }

        if (next.defaultDb) {
          return [next.value];
        }
      }
    }

    if (!firstEnabledItem) {
      throw "There are no Worldbook databases.";
    }

    return [firstEnabledItem.value];
  }
  getSearchParams() {
    return {
      searchTerm: LS2PAC_Utils.getQualifiedSearchTerm(
        this.searchTermInfo.value,
        this.searchTermInfo.type
      ),
      startIndex: this.currentPage * this.pageSize + 1,
      hitsPerPage: this.pageSize,
      facetFilters: [],
      branchFilters: [],
      sortCriteria: this.sortingData.sortKey,
      targetAudience: "",
      addToHistory: false,
      dbCodes: [],
      worldBookDatabaseList: this.worldBookDatabaseList,
    };
  }
  addExtraListeners() {
    var _this = this;

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.resetPageCache(true);
        if (_this.searchTermInfo) {
          _this.searchTermInfo.value = "";
        }
        _this.worldBookDatabaseList = _this.getDefaultWorldbookDatabaseList();
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onHome,
      function (event) {
        _this.resetPageCache(true);
        if (_this.searchTermInfo) {
          _this.searchTermInfo.value = "";
        }
        _this.worldBookDatabaseList = _this.getDefaultWorldbookDatabaseList();
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onFireAdvancedSearch,
      function (event) {
        _this.extraDataToPassBack.isAdvanced = true;
        _this.searchTermInfo = {
          value: JSON.stringify(event.searchString),
          type: LS2PAC_CONSTANTS.searchFields.advanced,
        };
        _this.resetPageCache(true);
        _this.getSearchCount();
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onChangeWorldBookDatabase,
      function (event) {
        if (event.database) {
          _this.worldBookDatabaseList = [event.database];
        }

        if (_this.isCurrent()) {
          _this.resetPageCache(false);
          _this.fireSearch(event);
          _this.addHistory(event);
        }
      }
    );
  }
}
